import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Folder, // Project Icon
  Wrench, // Job Icon
  Heart, 
  MessageSquare, 
  Search, 
  Plus, 
  Star, 
  MapPin, 
  Home 
} from "lucide-react";
import styles from "./HomeDashboard.module.css";
// import NavbarLogout from "../../components/Navbar/navbar-logout"; // Use your existing nav

const HomeUserDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('projects'); // 'projects' or 'jobs'

  // --- MOCK DATA ---
  const stats = {
    activeProjects: 2,
    activeJobs: 2,
    savedBusinesses: 4,
    unreadMessages: 3
  };

  const projects = [
    { 
      id: 1, 
      name: "Granny Flat Construction", 
      status: "Planning", 
      progress: 25, 
      nextTask: "Council Approval" 
    },
    { 
      id: 2, 
      name: "Kitchen Renovation", 
      status: "In Progress", 
      progress: 60, 
      nextTask: "Cabinet Installation" 
    }
  ];

  const jobs = [
    { 
      id: 101, 
      name: "Fix Leaking Tap", 
      status: "Quoting", 
      quotes: 3, 
      date: "Posted 2 days ago" 
    },
    { 
      id: 102, 
      name: "Install Ceiling Fan", 
      status: "Assigned", 
      quotes: 1, 
      date: "Scheduled for Tomorrow" 
    }
  ];

  const featuredBusinesses = [
    { id: 1, name: "Bright Spark Electrical", type: "Electrician", rating: 4.9, loc: "Bonnyrigg Heights", img: "/placeholder-sparky.jpg" },
    { id: 2, name: "Master Plumbers", type: "Plumbing", rating: 4.8, loc: "Liverpool", img: "/placeholder-plumber.jpg" },
    { id: 3, name: "Elite Tiling Co", type: "Tiling", rating: 5.0, loc: "Parramatta", img: "/placeholder-tiler.jpg" },
  ];

  return (
    <div className={styles.dashboardContainer}>
      
      {/* HEADER */}
      <header className={styles.header}>
        <div className={styles.container} style={{paddingTop:'1rem', paddingBottom:'1rem'}}>
          <div className={styles.headerContent}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
               <Home size={28} color="#F59E0B" />
               <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>BuildStart</span>
            </div>
            <div style={{color: 'white'}}>Stuart Mog (Homeowner)</div>
          </div>
        </div>
      </header>

      <div className={styles.container}>
        
        {/* WELCOME */}
        <div style={{ marginBottom: '1.5rem' }}>
          <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#0F172A', marginBottom: '0.5rem' }}>
            Welcome home, Stuart! 🏠
          </h1>
          <p style={{ color: '#64748B' }}>Manage your home improvement projects.</p>
        </div>

        {/* SEARCH BAR (For finding trades) */}
        <div className={styles.searchContainer}>
          <div style={{paddingLeft: '0.5rem', color:'#64748B'}}><Search size={20} /></div>
          <input 
            type="text" 
            placeholder="What trade are you looking for? (e.g. Plumber, Electrician)" 
            className={styles.searchInput}
          />
          <button className={styles.searchBtn}>Find Tradies</button>
        </div>

        {/* SLIM STATS STRIP */}
        <div className={styles.statsGrid}>
          <div className={styles.slimStatCard}>
            <div className={styles.statInfo}>
              <h3>Active Projects</h3>
              <p>{stats.activeProjects}</p>
            </div>
            <div className={styles.statIconBox}><Folder size={20} /></div>
          </div>
          <div className={styles.slimStatCard}>
            <div className={styles.statInfo}>
              <h3>Active Jobs</h3>
              <p>{stats.activeJobs}</p>
            </div>
            <div className={styles.statIconBox}><Wrench size={20} /></div>
          </div>
          <div className={styles.slimStatCard}>
            <div className={styles.statInfo}>
              <h3>Saved Businesses</h3>
              <p>{stats.savedBusinesses}</p>
            </div>
            <div className={styles.statIconBox}><Heart size={20} /></div>
          </div>
          <div className={styles.slimStatCard}>
            <div className={styles.statInfo}>
              <h3>Unread Messages</h3>
              <p>{stats.unreadMessages}</p>
            </div>
            <div className={styles.statIconBox}><MessageSquare size={20} /></div>
          </div>
        </div>

        {/* MAIN SPLIT LAYOUT */}
        <div className={styles.mainLayoutGrid}>
          
          {/* LEFT COLUMN: WORK LISTS */}
          <div className={styles.leftCol}>
            <div className={styles.tabContainer}>
              <div className={styles.tabHeader}>
                <button 
                  className={`${styles.tabButton} ${activeTab === 'projects' ? styles.activeTab : ''}`}
                  onClick={() => setActiveTab('projects')}
                >
                  My Projects ({projects.length})
                </button>
                <button 
                  className={`${styles.tabButton} ${activeTab === 'jobs' ? styles.activeTab : ''}`}
                  onClick={() => setActiveTab('jobs')}
                >
                  One-off Jobs ({jobs.length})
                </button>
              </div>

              <div className={styles.tabContent}>
                
                {/* PROJECTS TAB */}
                {activeTab === 'projects' && (
                  <>
                    {projects.map(project => (
                      <div key={project.id} className={styles.listItem}>
                        <div className={styles.itemMain}>
                          <h4>{project.name}</h4>
                          <div className={styles.itemMeta}>
                            <span style={{color: '#D97706', fontWeight: 600}}>Status: {project.status}</span>
                            <span>Next: {project.nextTask}</span>
                          </div>
                        </div>
                        <div style={{display:'flex', alignItems:'center'}}>
                           <div className={styles.progressWrap}>
                              <span className={styles.progressText}>{project.progress}% Complete</span>
                              <div className={styles.barBg}><div className={styles.barFill} style={{width: `${project.progress}%`}}></div></div>
                           </div>
                           <button className={styles.btnAction}>Manage</button>
                        </div>
                      </div>
                    ))}
                    <div style={{textAlign:'center', marginTop:'1.5rem', color:'#64748B', fontSize:'0.9rem'}}>
                        <Plus size={16} style={{marginBottom:'-3px'}}/> Create a new project for larger renovations
                    </div>
                  </>
                )}

                {/* JOBS TAB */}
                {activeTab === 'jobs' && (
                  <>
                    {jobs.map(job => (
                      <div key={job.id} className={styles.listItem}>
                        <div className={styles.itemMain}>
                          <h4>{job.name}</h4>
                          <div className={styles.itemMeta}>
                             <span style={{color: '#16A34A', fontWeight: 600}}>{job.status}</span>
                             <span>{job.date}</span>
                          </div>
                        </div>
                        <div style={{textAlign:'right'}}>
                           <div style={{fontSize:'0.85rem', color:'#64748B', marginBottom:'0.5rem'}}>
                             {job.quotes} Quotes Received
                           </div>
                           <button className={styles.btnAction}>View Quotes</button>
                        </div>
                      </div>
                    ))}
                  </>
                )}

              </div>
            </div>
          </div>

          {/* RIGHT COLUMN: SIDEBAR */}
          <div className={styles.sidebar}>
            
            {/* FEATURED BUSINESSES (Monetization) */}
            <div className={styles.sidebarCard}>
               <div className={styles.cardTitle}>
                  <Star size={18} color="#D97706" fill="#D97706" /> Featured Businesses
               </div>
               {featuredBusinesses.map(biz => (
                 <div key={biz.id} className={styles.featuredItem}>
                    {/* Placeholder image logic */}
                    <div className={styles.bizImg}></div> 
                    <div className={styles.bizInfo}>
                       <h5>{biz.name}</h5>
                       <p>{biz.type} • {biz.loc}</p>
                       <div className={styles.rating}>
                          <Star size={12} fill="#D97706"/> {biz.rating}
                       </div>
                    </div>
                 </div>
               ))}
               <button style={{width:'100%', padding:'0.5rem', background:'none', border:'none', color:'#0F172A', fontWeight:'600', cursor:'pointer', marginTop:'0.5rem'}}>
                 View More Local Pros →
               </button>
            </div>

            {/* QUICK ACTIONS */}
            <div className={styles.sidebarCard}>
              <div className={styles.cardTitle}>
                 <Plus size={18} color="#0F172A"/> Quick Actions
              </div>
              <button className={`${styles.qaBtn} ${styles.btnNavy}`} onClick={() => navigate('/new-project')}>
                 <Folder size={18}/> Start New Project
              </button>
              <button className={`${styles.qaBtn} ${styles.btnGold}`} onClick={() => navigate('/post-job')}>
                 <Wrench size={18}/> Post One-off Job
              </button>
            </div>

            {/* MESSAGES MINI */}
            <div className={styles.sidebarCard}>
               <div className={styles.cardTitle}>
                  <MessageSquare size={18}/> Recent Messages
               </div>
               {/* Reuse previous logic for message list */}
               <div style={{fontSize:'0.9rem', color:'#64748B'}}>
                  You have 3 unread messages from contractors.
               </div>
               <button style={{marginTop:'1rem', color:'#D97706', background:'none', border:'none', fontWeight:600, cursor:'pointer'}}>
                 Go to Inbox →
               </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default HomeUserDashboard;